import { FormikProps } from 'formik';
import React from 'react';
import { BeneficiaryCreateFormModel, BeneficiaryType } from '../model/beneficiary-create-models';
import { BeneficiarySettings } from '../model/epi-props';
import { CreateBeneficiaryOrganizationFields } from './create-beneficiary-org-fields';
import { CreateBeneficiaryPersonFields } from './create-beneficiary-person-fields';
import { GetOrgFormContentModel } from './helper/create-beneficiary-helper';


interface Props {
	type: BeneficiaryType;
	settings: BeneficiarySettings;
	formProps: FormikProps<BeneficiaryCreateFormModel>;
}
export function CreateBeneficiaryFieldsFactory(props: Props) {

	const { type, settings, formProps } = props;

	switch (type) {
		case BeneficiaryType.Person:
			return <CreateBeneficiaryPersonFields settings={settings} formProps={formProps} />;
		case BeneficiaryType.Entity:
			return <CreateBeneficiaryOrganizationFields
				content={GetOrgFormContentModel(type, settings)}
				settings={settings}
				formProps={formProps}
			/>;
		case BeneficiaryType.Trust:
			return <CreateBeneficiaryOrganizationFields
				content={GetOrgFormContentModel(type, settings)}
				settings={settings}
				formProps={formProps}
			/>;
		case BeneficiaryType.Estate:
			return <CreateBeneficiaryOrganizationFields
				content={GetOrgFormContentModel(type, settings)}
				settings={settings}
				formProps={formProps}
			/>;
		default:
			return <CreateBeneficiaryPersonFields settings={settings} formProps={formProps} />;
	}
}
